import {getAppLang, getProperty, getUserToken, isDefined} from "../../../../utils";
import axios from "axios";
import {
    REPUTATION_MANAGEMENT_LIST, REPUTATION_MANAGEMENT_SYNC,
    REPUTATION_MANAGEMENT_REVIEW, REPUTATION_MANAGEMENT_REVIEW_STATISTICS
    } from "../../../../constants/api.constants";
import { ReputationManagementConstants } from "../../../../constants/Network/reputationManagement.constants";

export function reputationManagementList (params) {

    const requestOptions = {
        headers: { 'Content-Type': 'application/json',  'authToken': getUserToken(), 'language' : getAppLang()},
        body: {
            params: {
                property_id : getProperty(),
            }
        }
    };

    requestOptions.body.params = {
        property_id : getProperty(),
    }

    return dispatch => {
        dispatch({
            type: 'REPUTATION_MANAGEMENT_LIST',
            payload: axios.post(REPUTATION_MANAGEMENT_LIST, requestOptions.body,{headers: requestOptions.headers})
                .then(response => response.data.data)
        })
    }
}

export function reputationManagementSync (params) {

    const requestOptions = {
        headers: { 'Content-Type': 'application/json',  'authToken': getUserToken(), 'language' : getAppLang()},
        body: {
            params: {
                property_id : getProperty(),
            }
        }
    };

    const { channel_id, ...parameters } = params;

    requestOptions.body.params = {
        property_id : getProperty(),
        channel_id : channel_id,
        channelDetail: {
            parameter: parameters
        }
    }

    return dispatch => {
        dispatch({
            type: 'REPUTATION_MANAGEMENT_SYNC',
            payload: axios.post(REPUTATION_MANAGEMENT_SYNC, requestOptions.body,{headers: requestOptions.headers})
                .then(response => response.data.data)
        })
    }
}

export function reputationManagementReviewStatistics(params = {}) {
    const requestOptions = {
        headers: { 'Content-Type': 'application/json',  'authToken': getUserToken(), 'language' : getAppLang()},
        body: {
            params: {
                property_id : getProperty(),
            }
        }
    };

    if (params.channel_id) {
        requestOptions.body.params = {
            property_id : getProperty(),
            page: params.page,
            per_page: params.per_page,
            filter: {
                channel_id: params.channel_id,
                start_date: params.start_date,
                end_date: params.end_date
            }
        }
    }

    return dispatch => {
        dispatch({
            type: 'REPUTATION_MANAGEMENT_REVIEW_STATISTICS',
            payload: axios.post(REPUTATION_MANAGEMENT_REVIEW_STATISTICS, requestOptions.body,{headers: requestOptions.headers})
                .then(response => response.data.data)
        })
    }
}

export function reputationManagementReview (params) {

    const requestOptions = {
        headers: { 'Content-Type': 'application/json',  'authToken': getUserToken(), 'language' : getAppLang()},
        body: {
            params: {
                property_id : getProperty(),
            }
        }
    };

    requestOptions.body.params = {
        property_id : getProperty(),
        page: params.page,
        per_page: params.per_page,
        filter: {
            channel_id: params.channel_id,
            start_date: params.start_date,
            end_date: params.end_date,
            keyword: params.keyword,
            sentiment: params.sentiment
        }
    }

    return dispatch => {
        dispatch({
            type: 'REPUTATION_MANAGEMENT_REVIEW',
            payload: axios.post(REPUTATION_MANAGEMENT_REVIEW, requestOptions.body,{headers: requestOptions.headers})
                .then(response => response.data.data)
        })
    }
}

export function reputationManagementListClear() {
    return dispatch => {
        dispatch({
            type: ReputationManagementConstants.REPUTATION_MANAGEMENT_LIST_CLEAR,
        })
    }
}

export function reputationManagementSyncClear() {
    return dispatch => {
        dispatch({
            type: ReputationManagementConstants.REPUTATION_MANAGEMENT_SYNC_CLEAR,
        })
    }
}

export function reputationManagementReviewClear() {
    return dispatch => {
        dispatch({
            type: ReputationManagementConstants.REPUTATION_MANAGEMENT_REVIEW_CLEAR,
        })
    }
}

export function reputationManagementReviewStatisticsClear() {
    return dispatch => {
        dispatch({
            type: ReputationManagementConstants.REPUTATION_MANAGEMENT_REVIEW_STATISTICS_CLEAR,
        })
    }
}